import * as R from 'ramda'

export const handlePercentage = (percentage, totalBurned, totalEarned) => {
  const floorPercentage = Math.floor(percentage)
  const totalEqualy = R.equals(totalBurned, totalEarned)

  if (floorPercentage === 0 && totalBurned === 0) return 0
  else if (floorPercentage === 0 && totalBurned > 0) return 1
  else if (floorPercentage === 99 && !totalEqualy) return 99
  else if (floorPercentage === 100 && totalEqualy) return 100
  else return Math.round(percentage)
}
